import React from "react";
import Image from "next/future/image";
import Link from "next/link";
import { useRouter } from "next/router";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import styles from "./carousel.module.scss";
import { buildApiUrl } from "src/helpers/imageHelpers";
import { Container } from "react-bootstrap";

export default function Carousel({ footerLinks, posts = [] }) {
  const router = useRouter();
  const { locale: lang } = router;
  const dir = lang === "ar" ? "rtl" : "ltr";

  const normalizeSettingValue = (value) =>
    typeof value === "string" ? value.replace(/`/g, "").trim() : "";

  const isRtl = lang === "ar";

  return (
    <div className={styles.wrapper}>
      <Swiper
        modules={[Pagination, Autoplay, EffectFade]}
        pagination={{ clickable: true }}
        effect={"fade"}
        slidesPerView={1}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        dir={dir}
        key={dir}
      >
        {posts?.map((post, index) => {
          const ctaText =
            normalizeSettingValue(post?.data?.ctaText?.[lang]) ||
            normalizeSettingValue(post?.data?.ctaText?.ar) ||
            normalizeSettingValue(post?.data?.ctaText?.en);
          const ctaUrl = normalizeSettingValue(post?.data?.ctaUrl);
          const isExternalCtaUrl = /^https?:\/\//i.test(ctaUrl);

          return (
            <SwiperSlide key={index}>
              <div className="overlay"></div>
              <Image
                src={buildApiUrl(post?.data?.image)}
                alt={`slider-${index}`}
                priority={index === 0}
                loading={index === 0 ? "eager" : "lazy"}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
                width={1900}
                height={1000}
                quality={index === 0 ? 85 : 75}
              />
              <Container className="h-100">
                <div className="text">
                  <h2>{post?.data?.title?.[lang]}</h2>
                  <p>{post?.data?.description?.[lang]}</p>
                  {ctaText && ctaUrl ? (
                    isExternalCtaUrl ? (
                      <a
                        href={ctaUrl}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.ctaLink}
                      >
                        {ctaText}
                        <div className={styles["icon-circle"]}>
                          <svg
                            style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.53577 3.53556L14.1424 14.1422"
                              stroke="black"
                              strokeWidth={1.5}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                              stroke="black"
                              strokeWidth={1.5}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </a>
                    ) : (
                      <Link href={ctaUrl} legacyBehavior>
                        <a className={styles.ctaLink}>
                          {ctaText}
                          <div className={styles["icon-circle"]}>
                            <svg
                              style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.53577 3.53556L14.1424 14.1422"
                                stroke="black"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                                stroke="black"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </a>
                      </Link>
                    )
                  ) : null}
                </div>
              </Container>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
